import authService from "../services/auth.service";
import { getAuth } from "../services/main.service";


const token = JSON.parse(localStorage.getItem("token"));

export const auth = {
  namespaced: true,
  state: {
    loggedIn: !!token,
    userRoutePermissions: [],
    userLogin: null,
    userId: null,
    userName: null,
  },
  actions: {
    async initializeApp({ dispatch, state }) {
      if (state.loggedIn) {
        await dispatch("fetchAuth");
      }
    },
    async login({ commit }, userData) {
      await authService.login(userData);
      commit("logMeIn");
    },

    async logout({ commit }) {
      try {
        await authService.logout();
      } finally {
        commit("logMeOut");
      }
    },

    async register({ commit }, userData) {
      try {
        const response = await authService.register(userData);
        return response;
      } catch (error) {
        return error.response.data;
      }
    },
    async acessoAntecipado({ commit }, userData) {
      try {
        const response = await authService.acessoAntecipado(userData);
        return response;
      } catch (error) {
        return error;
      }
    },
    async fetchUserRoutePermissionsFromBackend({ commit }) {
      try {
        const response = await Axios.useAxios('get', '/user/route-permissions');
        commit('setUserRoutePermissions', response.data.routes);
        return response.data.routes;
      } catch (error) {
        throw error;
      }
    },
    async fetchUserRoutePermissionsFromBackendAula({ state }, slug_disciplina) {
      try {
        const response = await Axios.useAxios('get', '/user/has-permission-aula/' + slug_disciplina);
        return response.data.status;
      } catch (error) {
        throw error;
      }
    },
    async checkRoutePermission({ state }, routeName) {
      if (!state.userRoutePermissions.length) {
        await this.dispatch('auth/fetchUserRoutePermissionsFromBackend');
      }
      return state.userRoutePermissions.includes(routeName);
    },
    async fetchAuth({ commit }) {
      try {
        const response = await getAuth();
        commit('setUserId', response.data.me.safe_id);
        commit('setUserLogin', response.data.me.login);
        commit('setUserName', response.data.me.name);
      } catch (error) {
        throw error;
      }
    },
  },
  mutations: {
    logMeIn(state) {
      state.userRoutePermissions = [];
      state.loggedIn = true;
    },
    logMeOut(state) {
      state.loggedIn = false;
    },
    setUserRoutePermissions(state, permissions) {
      state.userRoutePermissions = permissions;
    },
    setUserLogin(state, login) {
      state.userLogin = login;
    },
    setUserId(state, id) {
      state.userId = id;
    },
    setUserName(state, name) {
      state.userName = name;
    },
  },

  getters: {
    loggedIn(state) {
      return state.loggedIn;
    },
    userId(state) {
      return state.userId;
    },
    userLogin(state) {
      return state.userLogin;
    },
    // isVip(state, getters, rootState) {
    //   const productsPaid = rootState.cart.productsPaid;
    //   if (!productsPaid || productsPaid.length > 3) {
    //     return false;
    //   }
    //   return state.userVIP;
    // }
  },
};
